import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=2ddf10b8&"
import script from "./selectCustomer.vue?vue&type=script&lang=js&"
export * from "./selectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./selectCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports